import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Only import the API check in development mode
if (process.env.NODE_ENV === 'development') {
  // This will automatically run the API connection check
  import('./utils/checkApiConnection');
  console.log('API connection check is running in development mode');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
